import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';


// Use createRoot 
const root = createRoot(document.getElementById('root'));
root.render(<App />);

reportWebVitals();